export default "__VITE_ASSET__CfIZ_n_N__"